module.exports = __webpack_public_path__ + "56e7d5b3213286e19d6378293217f4d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/ueberfremdung_unclear.svg
// module id = 65
// module chunks = 0